import { NoTranslate } from "@/core/components/ui/no-translate";
import useTypedTranslation from "@/core/hooks/use-typed-translation";
import { cn } from "@/core/utils/func/cn";
import { getDisplayAppVersion } from "@/core/utils/func/constants";

type AppVersionLabelProps = {
  className?: string;
  /** Masque le libellé i18n (ex. rail sidebar replié). */
  hideLabel?: boolean;
};

/**
 * Libellé discret de la version applicative (`vX.Y.Z`).
 * Le numéro est une donnée technique : `NoTranslate`.
 */
export function AppVersionLabel({
  className,
  hideLabel = false,
}: AppVersionLabelProps) {
  const { t } = useTypedTranslation();
  const version = getDisplayAppVersion();
  if (!version) return null;

  return (
    <p
      className={cn("text-xs text-muted-foreground", className)}
      aria-label={`${t("common.version")} ${version}`}
    >
      {hideLabel ? null : (
        <>
          {t("common.version")}{" "}
        </>
      )}
      <NoTranslate as="span" className="tabular-nums">
        {version}
      </NoTranslate>
    </p>
  );
}
